import React from 'react'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import { Button, FullBlockLoader, CircleLoader } from '@deal/components'
import { withRouter, RouteComponentProps, Link } from 'react-router-dom'
import Logger from '#src/services/logger'
import { Server } from '#src/components/Errors'
import { generateCreateUrlFromCategory } from '#src/services/path'
import styles from './styles.css'
import {
  ExperienceDetailsFragment,
  RecommendedExpertForRequestComponent,
  RequestSellableComponent,
  SellableUrlFragment
} from '#src/generated/graphql'
import Duration from './Duration'

interface PricingProps extends RouteComponentProps<any> {
  sellable: ExperienceDetailsFragment
  categorySlug: string | null
  categoryId: string
  onVariationSelected: (sellable: SellableUrlFragment) => void
}

interface DefaultButtonProps {
  categorySlug: string | null
}

const DefaultButton: React.SFC<DefaultButtonProps> = ({ categorySlug }) => {
  return (
    <Link
      to={generateCreateUrlFromCategory({
        maybeCategorySlug: categorySlug,
        sourceKey: 'yacht-pricing',
        pathIntent: 'request'
      })}
    >
      <Button className={styles.requestToBook}>Request to book</Button>
    </Link>
  )
}

const ExperienceDetailsPricing: React.SFC<PricingProps & WithIdentityProps> = ({
  categorySlug,
  categoryId,
  sellable,
  history,
  myself,
  onVariationSelected
}) => {
  return (
    <div className={styles.container}>
      <Duration sellableId={sellable.id} onVariationSelected={onVariationSelected} />

      <div className={styles.wrapper}>
        {myself ? (
          <RecommendedExpertForRequestComponent
            variables={{
              categoryId,
              consumerId: myself.id
            }}
          >
            {({ data, loading, error }) => {
              if (error) {
                Logger.captureException(`Error getting recommended expert: ${error}`)

                return <Server />
              } else if (loading) {
                return <FullBlockLoader loader={CircleLoader} />
              } else if (data && data.recommendExpert2 && data.recommendExpert2.expert) {
                return (
                  <RequestSellableComponent
                    onCompleted={({ requestSellable }) => {
                      if (requestSellable.lead) {
                        history.push(`/inbox/${requestSellable.lead.conversation.externalId}`)
                      } else {
                        history.push(
                          generateCreateUrlFromCategory({
                            maybeCategorySlug: categorySlug,
                            sourceKey: 'yacht-pricing-recommended-expert',
                            pathIntent: 'request'
                          })
                        )
                      }
                    }}
                    variables={{
                      input: {
                        expertId: data.recommendExpert2.expert.id,
                        sellableId: sellable.id
                      }
                    }}
                  >
                    {(requestSellable, { loading }) => {
                      return (
                        <Button
                          className={styles.requestToBook}
                          disabled={loading}
                          onClick={() => requestSellable()}
                        >
                          Interested
                        </Button>
                      )
                    }}
                  </RequestSellableComponent>
                )
              } else {
                return <DefaultButton categorySlug={categorySlug} />
              }
            }}
          </RecommendedExpertForRequestComponent>
        ) : (
          <DefaultButton categorySlug={categorySlug} />
        )}
      </div>
    </div>
  )
}

export default withIdentity(withRouter(ExperienceDetailsPricing))
